export default __webpack_public_path__ + "static/media/configuration.32c94cab.svg";